import Image from 'next/image'

import { Heading } from '@infura/packages.ui/Heading'
import { Text } from '@infura/packages.ui/Text'

export const NoKeyWarning = () => {
  return (
    <div className='mx-auto flex max-w-3xl flex-col items-center'>
      <Image alt='' className='mx-auto mb-4' height='87' src='/images/no-api-keys.svg' width='117' />
      <Heading className='text-center text-lg' data-testid='table-no-keys' theme='section'>
        You don’t have any API Keys yet.
      </Heading>
      <Text className='text-center'>To start using MetaMask Developer, create an API to access your API keys.</Text>
    </div>
  )
}
